import View from './View.js';
import previewView from './previewView.js';
import * as model from '../model.js';
import icons from 'url:../../img/icons.svg'; //Parcel 2

class ResultsView extends View {
  _parentElement = document.querySelector('.results');
  _sortBtn = document.querySelector('.btn--sort');
  _errorMessage = `No recipe found for your search. Please try again!`;
  _message = ``;

  _showSortBtn(isData) {
    isData
      ? this._sortBtn.classList.remove('hidden')
      : this._sortBtn.classList.add('hidden');
  }

  _generateMarkup() {
    return this._data.map(result => previewView.render(result, false)).join('');
  }

  addHandlerClick(handler) {
    this._sortBtn.addEventListener('click', function (e) {
      handler();
    });
  }

  highlightSortBtn(isSored) {
    if (isSored) {
      this._sortBtn.style.backgroundImage =
        'linear-gradient(to right bottom, #fbdb8970, #f48a823a)';
    } else {
      this._sortBtn.style.backgroundImage = 'none';
    }
  }
}

export default new ResultsView();
